// components/ScrollArrow.jsx
import './ScrollArrow.css';   // inside ScrollArrow.jsx
import React from 'react';
import ArrowImage from '../assets/Links/Arrow.png';

const ScrollArrow = ({ onClick }) => {
  return (
    <div className="scroll-arrow" onClick={onClick}>
      <img src={ArrowImage} alt="Scroll down" />
    </div>
  );
};

export default ScrollArrow;
